import { clsx } from 'clsx';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'animate-shimmer rounded-xl bg-gradient-to-r from-surface-200 via-surface-100 to-surface-200',
        'dark:from-surface-800 dark:via-surface-700 dark:to-surface-800',
        'bg-[length:200%_100%]',
        className,
      )}
    />
  );
}

export function QuoteSkeleton() {
  return (
    <div className="glass-card space-y-4">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
      <Skeleton className="h-4 w-2/3" />
      <div className="flex items-center gap-4 pt-4">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
    </div>
  );
}
